<template>
  <b-row>
    <h5 class="col-12">Imágenes</h5>
    
    <b-col md="12">
      <!-- Campo de búsqueda de imágenes -->
      <b-row v-if="imagenes">        
        <v-select     
          class="col-10"
          placeholder="Escribe el nombre de la imagen..."
          v-model="selectedImagen"
          :options="filteredImagenes"
          label="text"
          @search="onSearchImagenes"
          :loading="isLoading"
          :debounce="300"
        >
          <template #no-options>
            {{ noImagenesMessage() }}
          </template>
        </v-select>
      </b-row>

      <!-- Formulario (mostrado solo si mostrarFormulario es true y hay una imagen seleccionada) -->
      <div v-if="selectedImagen && mostrarFormulario" class="my-2">
        <b-row class="my-1 d-flex align-items-center">
          <label class="col-2">Lateralidad</label>
          <v-select 
            class="col-4"
            id="v-lateralidad" 
            v-model="selectedLateralidad"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"  
            :options="opsLateridades"
            label="text"  
          />
        
          <label class="col-2">¿Requiere sedación?</label>
          <v-select 
            class="col-4"
            id="v-sedacion" 
            v-model="sedacion"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"  
            :options="optSedacion"
            label="text"  
          />
        </b-row>

        <b-row class="my-1 d-flex align-items-center">
          <label class="col-2">Motivo de Solicitud</label>
          <b-form-textarea 
            class="col mx-1"
            v-model="motivosolicitud"
            placeholder="Escriba el motivo de la solicitud..." 
            rows="2" 
            no-resize
          />
        </b-row>

        <b-row class="my-1 d-flex align-items-center">
          <label class="col-2">Resumen Clínico</label>
          <b-form-textarea 
            class="col mx-1"
            v-model="resumen"
            placeholder="Escriba el resumen clínico..." 
            rows="2" 
            no-resize
          />
        </b-row>

        <b-row class="my-1 d-flex align-items-center" v-if="selectedImagenRepetida">
          <label class="col-2">Justificación</label>
          <b-form-textarea 
            class="col mx-1"
            v-model="justificacion"
            placeholder="Escriba la justificación..." 
            rows="2" 
            no-resize
          />
        </b-row>

        <b-row class="my-2 d-flex justify-content-end">
          <b-button 
            variant="info" 
            size="sm" 
            @click="agregarImagen()" 
            style="cursor: pointer;"
            class="mx-1"
          >
            <i class="fas fa-solid fa-plus" title="Agregar Imagen"/>
            Agregar
          </b-button>
          <b-button 
            variant="secondary" 
            size="sm" 
            @click="limpiarFormulario()" 
            style="cursor: pointer;"
            class="mx-1"
          >
            <i class="fas fa-eraser" title="Limpiar Formulario"/>
            Limpiar
          </b-button>
        </b-row>
      </div>

      <!-- Tabla de imágenes registradas -->
      <div v-if="imagenes && imagenes.length > 0">
        <b-row>
          <b-col>
            <b-table 
              :items="imagenes" 
              :fields="fieldsre" 
              striped bordered
            >
              <template #cell(imagentext)="data">
                {{ data.item.imagentext }} 
              </template>
              <template #cell(sedacion)="data">
                {{ data.item.sedacion === '1' ? 'Sí' : 'No' }} 
              </template>
              <template #cell(acciones)="data">
                <div class="d-flex justify-content-end">
                  <b-button 
                    variant="primary" 
                    size="sm" 
                    style="cursor: pointer;"
                    @click="editItem(data.item, data.index)"
                  >
                    <font-awesome-icon 
                      icon="user-pen" 
                      style="color: rgb(253, 253, 253);" 
                    />
                  </b-button>
                  <b-button 
                    variant="danger" 
                    size="sm" 
                    style="cursor: pointer;" 
                    @click="removeImagen(data.item)"
                  >
                    <font-awesome-icon 
                      icon="circle-xmark" 
                      style="color: rgb(255, 255, 255);" 
                    />
                  </b-button>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </div>

      <!-- Modal para editar imágenes -->
      <b-modal 
        id="edit-image-modal" 
        v-model="showEditImageModal" 
        title="Editar Imagen" 
        @hide="resetEditImageForm"
        ok-title="Guardar"
        @ok="onSubmitEditImage"
        cancel-title="Cancelar"
        @cancel="resetEditImageForm"
      >
        <b-form @submit.prevent="onSubmitEditImage">
          <b-form-group label-for="v-lateralidad">
            <span>Lateralidad</span>
            <v-select 
              id="v-lateralidad" 
              v-model="editImageForm.lateralidad"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"  
              :options="opsLateridades"
              label="text"  
            />
          </b-form-group>
          <b-form-group label="Motivo de Solicitud" label-for="edit-motivosolicitud">
            <b-form-textarea
              id="edit-motivosolicitud"
              v-model="editImageForm.motivosolicitud"
              rows="3"
              required 
            />
          </b-form-group>
          <b-form-group label="Resumen Clínico" label-for="edit-resumen">
            <b-form-textarea
              id="edit-resumen"
              v-model="editImageForm.resumen"
              rows="3"
              required 
            />
          </b-form-group>
        </b-form>
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import vSelect from 'vue-select'
import rutas from '@/assets/utils/rutas.json';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import { ValidationProvider } from 'vee-validate'
import { mapState } from "vuex";
import axios from 'axios';
import _ from 'lodash';
import { imagenesService } from '@/views/imagen/services';

export default {
  name: 'CrearDerivacionImagen',
  components: {
    ValidationProvider,
    vSelect,
  },
  data() {
    return {
      sedacion: { text: 'No', value: '2' },
      optSedacion: [{ text: 'Sí', value: '1' }, { text: 'No', value: '2' }],
      visibleBody: false,
      justificacion: '',
      selectedImagenRepetida: false,
      continuar: false,
      alertaOmitida: 0,
      selectedOption: null,
      isLoading: false,
      opsLateridades: [],
      searchFailed: false,
      searchQuery: '',
      noOptionsMessage: "Ingresa palabras clave para buscar.",
      visible: false,
      collapseItemID: '',
      titularsel3: '',
      selectedImagen: null,
      openOnHover: this.$parent.hover,
      options: {},
      filteredImagenes: [],
      imagenes: [],
      antecedentes: [],
      motivosolicitud: '',
      resumen: '',
      norden: '',
      selectedLateralidad: null,
      titularsel2: '',
      lateralidad: null,
      signosVitalesExisten: false,
      itemSignosVital: null,
      showEditImageModal: false,
      editImageForm: {
        lateralidad: null,
        norden: '',
        motivosolicitud: '',
        resumen: '',
      },
      editingIndex: null,
      mostrarFormulario: false, // Controla la visibilidad del formulario
      opsMenu2: [
        { value: '0', text: 'INFORMACIÓN SOBRE LA REACCIÓN ADVERSA' },
        { value: '1', text: 'INFORMACIÓN DEL MEDICAMENTO' },
        { value: '2', text: 'DESENLACE' }
      ],
      fieldsre: [
        { key: 'imagentext', label: 'Imagen', thClass: 'text-center' },
        { key: 'lateralidad', label: 'Lateralidad', thClass: 'text-center' },
        { key: 'motivosolicitud', label: 'Motivo de Solicitud', thClass: 'text-center' },
        { key: 'resumen', label: 'Resumen Clínico', thClass: 'text-center' },
        { key: 'sedacion', label: 'Sedación', thClass: 'text-center' },
        { key: 'acciones', label: 'Acciones', sortable: true, thClass: 'text-center', tdClass: 'text-right' },
      ],
      opsMenu5: [
        { value: '0', text: 'Una vez al día' },
        { value: '1', text: 'Cada 12 horas' },
        { value: '2', text: 'Dos veces al día' }
      ],
      opsMenu3: [
        { value: '0', text: 'CONJUTIVITIS' },
        { value: '1', text: 'DISPLASIA CERVICAL LEVE' },
        { value: '2', text: 'PAPILOMAVIRUS' }
      ],
    };
  },
  created() {
    this.debouncedGetImagenes = _.debounce((search) => this.obtenerImagenes(search), 100);
    this.fetchLateridades();
  },
  methods: {
    validateKeyPress(campo, event) {
      if (campo === "norden" && this.norden.length >= 10 && !['Backspace', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
        event.preventDefault();
      }
    },
    noImagenesMessage() {
      if (this.searchQuery.length < 4) 
        return 'Escribe más caracteres para buscar...';
      if (this.isLoading)  
        return 'Buscando imágenes...';
      if (this.searchFailed) 
        return 'Error al buscar imágenes. Intente de nuevo.';
      if (this.filteredImagenes.length === 0 && !this.isLoading) 
        return 'No se encontraron imágenes que coincidan con tu búsqueda';
      return 'Escribe para buscar imágenes...';
    },
    async obtenerImagenes(search) {
      const responseImagenes = await imagenesService.getAllSns(search);
      this.filteredImagenes = responseImagenes.map(item => ({
        value: item.id,
        text: `${item.codigo} - ${item.nombre}`,
        nombre: item.nombre,
        codigo: item.codigo
      }));
    },
    async fetchLateridades() {
      const query = `
        query {
          allLateridades {
            id
            descripcion
            nombre
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        this.opsLateridades = response.data.data.allLateridades.map(item => ({
          value: item.id,
          text: item.nombre,
        }));
      } catch (error) {
        console.error("Error fetching especialidades:", error.response.data);
      }
    },
    onSearchImagenes(search, loading) {
      if (search.length > 2) {
        this.isLoading = true;
        loading(true);
        this.searchQuery = search;
        this.debouncedGetImagenes(search);
      } else {
        this.filteredImagenes = [];
        this.isLoading = false;
      }
      loading(false);
    },
    removeImagen(imagen) {
      this.$swal({
        title: '¿Estás seguro de eliminar esta imagen?',
        text: "¡No podrás revertir esta acción!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar!',
        cancelButtonText: 'No, cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          const index = this.imagenes.indexOf(imagen);
          if (index > -1) {
            this.imagenes.splice(index, 1);
            localStorage.setItem('atencionImagenes', JSON.stringify(this.imagenes));
            this.$swal(
              'Eliminado!',
              'La imagen ha sido eliminada.',
              'success'
            );
          }
        }
      }).catch(error => {
        console.error("Error al eliminar la imagen:", error);
        this.$swal(
          'Error',
          'Ocurrió un error al intentar eliminar la imagen.',
          'error'
        );
      });
    },
    editItem(item, index) {
      this.editImageForm = JSON.parse(JSON.stringify(item));
      const lateralidadObj = this.opsLateridades.find(option => option.value === item.lateralidadId);
      if (lateralidadObj) {
        this.editImageForm.lateralidad = lateralidadObj;
      }
      this.editingIndex = index;
      this.showEditImageModal = true;
    },
    resetEditImageForm() {
      this.editImageForm = this.getDefaultImageForm();
      this.editingIndex = null;
      this.showEditImageModal = false;
    },
    onSubmitEditImage() {
      if (this.editingIndex !== null) {
        if (!this.editImageForm.motivosolicitud || !this.editImageForm.resumen) {
          this.$swal({
            title: 'Error',
            text: 'Por favor, complete todos los campos requeridos antes de editar la imagen.',
            icon: 'warning',
            confirmButtonText: 'Ok'
          });
          return;
        }
        if (!this.editImageForm.lateralidad?.value) {
          this.editImageForm.lateralidad = this.imagenes[this.editingIndex].lateralidad;
        } else {
          this.editImageForm.lateralidad = this.editImageForm.lateralidad.text;
        }
        this.$set(this.imagenes, this.editingIndex, this.editImageForm);
        localStorage.setItem('atencionImagenes', JSON.stringify(this.imagenes));
        this.$store.commit('setDerivacionesDataForm', { imagenes: this.imagenes });
        this.showEditImageModal = false;
        this.editingIndex = null;
      } else {
        console.error('Error: No hay índice de edición definido.');
      }
    },
    getDefaultImageForm() {
      return {
        lateralidad: null,
        norden: '',
        motivosolicitud: '',
        resumen: '',
      };
    },
    resetFormulario() {
      this.selectedLateralidad = null;
      this.sedacion = { text: 'No', value: '2' };
      this.motivosolicitud = '';
      this.resumen = '';
      this.justificacion = '';
      this.norden = '';
    },
    async agregarImagen() {
      if (
        !this.selectedImagen || 
        !this.selectedLateralidad || 
        !this.motivosolicitud || 
        !this.resumen || 
        (this.selectedImagenRepetida && !this.justificacion)
      ) {
        this.$swal({
          title: 'Error',
          text: 'Por favor, complete todos los campos requeridos antes de agregar la imagen.',
          icon: 'error',
          confirmButtonText: 'Ok',
        });
        return;
      }

      const nuevaImagen = {
        imagenId: this.selectedImagen.value,
        imagentext: this.selectedImagen.text,
        codigo: this.selectedImagen.codigo,
        norden: this.norden,
        lateralidad: this.selectedLateralidad.text,
        lateralidadId: this.selectedLateralidad.value,
        motivosolicitud: this.motivosolicitud,
        resumen: this.resumen,
        alertaIgnorada: this.alertaOmitida,
        justificacion: this.justificacion,
        sedacion: this.sedacion.value,
      };

      this.imagenes.push(nuevaImagen);
      localStorage.setItem('atencionImagenes', JSON.stringify(this.imagenes));
      this.$store.commit('setDerivacionesDataForm', { imagenes: this.imagenes });

      this.$swal({
        title: 'Éxito',
        text: 'Imagen agregada correctamente.',
        icon: 'success',
        confirmButtonText: 'Ok',
      });

      // Ocultar el formulario y limpiar solo el campo de selección
      this.mostrarFormulario = false;
      this.selectedImagen = null;
      // No limpiar otros campos aquí, se manejará en el watch
    },
    limpiarFormulario() {
      this.selectedImagen = null;
      this.norden = '';
      this.selectedLateralidad = null;
      this.motivosolicitud = '';
      this.resumen = '';
      this.justificacion = '';
      this.sedacion = { text: 'No', value: '2' };
      this.mostrarFormulario = false;
    },
    resetearImagenesEnviada() {
      this.$swal({
        title: '¿Estás seguro?',
        text: 'Esta acción no se puede deshacer y eliminará todas las imágenes guardadas.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, resetear',
        cancelButtonText: 'No, cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          localStorage.removeItem('atencionImagenes');
          this.imagenes = [];
          this.$swal({
            title: 'Reset Completo',
            text: 'Las imágenes han sido reseteadas.',
            icon: 'success',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Ok'
          });
        }
      });
    },
    async validateSelectedImagen() {
      const imagenRepetida = this.imagenes.find(imagen => imagen.imagenId === this.selectedImagen.value);
      this.selectedImagenRepetida = imagenRepetida;

      if (!imagenRepetida) return;

      await this.$swal({
        title: 'Imagen ya agregada',
        text: `La imagen "${imagenRepetida.imagentext}" ya está en la lista. Por favor, proporcione una justificación para agregarla nuevamente.`,
        icon: 'warning',
        confirmButtonText: 'Ok',
      });
      this.mostrarFormulario = true; // Mostrar formulario para ingresar justificación
    },
  },
  computed: {
    ...mapState({
      stData: state => state.derivaciones.modalCompletarDerivacion.zData,
    }),
  },
  watch: {
    imagenes: {
      deep: true,
      handler(newValue) {
        this.$store.commit('setDerivacionesDataForm', { imagenes: newValue });
      }
    },
    selectedImagen(newValue) {
      if (newValue) {
        this.validateSelectedImagen();
        this.resetFormulario(); // Reiniciar campos al seleccionar una nueva imagen
        this.mostrarFormulario = true; // Mostrar formulario
      } else {
        this.mostrarFormulario = false; // Ocultar formulario si no hay imagen seleccionada
      }
    },
    stData: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.imagenes = [...(newValue.imagenes || [])];
      }
    }
  }
}
</script>